import { apiRequest } from "../services/ApiService.js";

import {
  CLAIM_ID_SET,
  CLAIM_STATUS_SET,
  CLAIM_CLEAR_ITEMS,
  CLAIM_TYPE_SET,
  CLAIM_GET_CLAIM_DETAILS,
  CLAIM_GET_CLAIM_DETAILS_FAILED,
  CLAIM_GET_CLAIM_DETAILS_SUCCESS,
  CLAIM_GET_ID,
  CLAIM_GET_ID_FAILED,
  CLAIM_GET_ID_SUCCESS,
  CLAIM_GET_PENDING_CLAIMS,
  CLAIM_GET_PENDING_CLAIMS_FAILED,
  CLAIM_GET_PENDING_CLAIMS_SUCCESS,
  CLAIM_ITEM_ADD,
  CLAIM_ITEM_ADD_FAILED,
  CLAIM_ITEM_ADD_SUCCESS,
  CLAIM_ITEM_REMOVE,
  CLAIM_ITEM_REMOVE_FAILED,
  CLAIM_ITEM_REMOVE_SUCCESS,
  CLAIM_STATE_CANCEL,
  CLAIM_STATE_CANCEL_FAILED,
  CLAIM_STATE_CANCEL_SUCCESS,
  CLAIM_SAVE,
  CLAIM_SAVE_FAILED,
  CLAIM_SAVE_SUCCESS,
  CLAIM_RECEIPT_ADD,
  CLAIM_RECEIPT_ADD_FAILED,
  CLAIM_RECEIPT_ADD_SUCCESS,
  CLAIM_RECEIPT_REMOVE,
  CLAIM_RECEIPT_REMOVE_SUCCESS,
  CLAIM_SUBMIT,
  CLAIM_SUBMIT_FAILED,
  CLAIM_SUBMIT_SUCCESS,
  CLAIM_CANCEL,
  CLAIM_AUDIT_UPLOAD_SUBMIT,
  CLAIM_AUDIT_UPLOAD_SUBMIT_FAILED,
  CLAIM_AUDIT_UPLOAD_SUBMIT_SUCCESS,
  SNACKBAR_SET,
  GENERAL_REQUEST_LOADED
} from './types';

import history from '../utility/common/History.js';
import { HSAMaxImageSize, inArray } from '../utility/common/GlobalHSA.js';

// ******************************************************************** //
// ************ General *********************************************** //
// ******************************************************************** //

// ******************************************************************** //
// ************ Get Pending Claims ********************************* //
// ******************************************************************** //
export const authPendingClaims = (userId, type, token) => {
  return (dispatch) => {

    dispatch({ type: CLAIM_GET_PENDING_CLAIMS });

    const data = { ee: userId, type: type }
    const responseDispatches = { fail: CLAIM_GET_PENDING_CLAIMS_FAILED, success: CLAIM_GET_PENDING_CLAIMS_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };

    //claimRequest(dispatch, `${REACT_APP_API_URL}/claims/pending`, data, responseDispatches, responseRedirects, showSnackBar, token);
    apiRequest(dispatch, history, token, '/claims/pending', data, responseDispatches, responseRedirects, showSnackBar, responseFunctions, false, false);

  };
};

// ******************************************************************** //
// ************ Get Claim ID ****************************************** //
// ******************************************************************** //
export const authClaimIdRequest = (userId, token) => {
  return (dispatch) => {

    dispatch({ type: CLAIM_GET_ID });

    claimIdValidation(dispatch, userId, token);

  };
};

const claimIdValidation = (dispatch, userId, token) => {

  let errors = {};

  if(
    isNaN(userId) ||
    userId === 0 ||
    userId === ''
  ) errors.GENERAL = `Invalid Employee ID`;

  const data = { ee: userId }
  const responseDispatches = { fail: CLAIM_GET_ID_FAILED, success: CLAIM_GET_ID_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const responseFunctions = { fail: null, success: null };
  const showSnackBar = { fail: true, success: false };

  if(Object.keys(errors).length > 0){
    claimRequestFail(
      dispatch,
      true,
      errors,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail
    );
  } else {
    //claimRequest(dispatch, `${REACT_APP_API_URL}/claim/id`, data, responseDispatches, responseRedirects, showSnackBar, token, responseFunctions);
    apiRequest(dispatch, history, token, '/claim/id', data, responseDispatches, responseRedirects, showSnackBar, responseFunctions, false, false);
  
  }

}


// ******************************************************************** //
// ************ General Actions *************************************** //
// ******************************************************************** //
export const setClaimId = (id) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_ID_SET, payload: id });
  };
};

// ******************************************************************** //
export const setClaimStatus = (status) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_STATUS_SET, payload: status });
  };
};

// ******************************************************************** //
export const setClaimType = (type,status) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_TYPE_SET, payload: type });
    if(status === 'R'){
      history.push('/claims/resume');
    } else {
      history.push('/claims/details');
    }
  };
};

// ******************************************************************** //
export const clearClaimItems = () => {
  return (dispatch) => {
    dispatch ({ type: CLAIM_CLEAR_ITEMS });
  };
}

// ******************************************************************** //
// ************ Get Patients/Dependants ******************************* //
// ******************************************************************** //
export const authClaimDetailsRequest = (userId, claimType, claimStatus, token) => {
  return (dispatch) => {

    dispatch({ type: CLAIM_GET_CLAIM_DETAILS, claimType: claimType, claimStatus: claimStatus });

    claimDetailsValidation(dispatch, userId, claimType, token);

  };
};

const claimDetailsValidation = (dispatch, userId, claimType, token) => {

  let errors = {};

  if(
    isNaN(userId) ||
    userId === 0 ||
    userId === ''
  ) errors.GENERAL = `Invalid Employee ID`;

  if(['HSA','WSA'].indexOf(claimType) === -1) errors.GENERAL = `Invalid claim type`;

  const data = { ee: userId, type: claimType }
  const responseDispatches = { fail: CLAIM_GET_CLAIM_DETAILS_FAILED, success: CLAIM_GET_CLAIM_DETAILS_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const responseFunctions = { fail: null, success: null };
  const showSnackBar = { fail: true, success: false };

  if(Object.keys(errors).length > 0){
    claimRequestFail(
      dispatch,
      true,
      errors,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail
    );
  } else {
    //claimRequest(dispatch, `${REACT_APP_API_URL}/claims/details`, data, responseDispatches, responseRedirects, showSnackBar, token, responseFunctions);
    apiRequest(dispatch, history, token, '/claims/details', data, responseDispatches, responseRedirects, showSnackBar, responseFunctions, false, false);
  }

}

// ******************************************************************** //
// ************ Claim Item Add / Remove ******************************* //
// ******************************************************************** //
export const claimItemAdd = (employee, claimType, claimItemObj, claimDateRange, claimItems, submitableAmount, token, resetForm) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_ITEM_ADD });
    //dispatch({ type: CLAIM_ITEM_ADD_SUCCESS });
    //validate return code
    processClaimItemAdd(dispatch, employee, claimType, claimItemObj, claimDateRange, claimItems, submitableAmount, token, resetForm);
  }
}

const processClaimItemAdd = (dispatch, employee, claimType, claimItemObj, claimDateRangeObj, claimItems, submitableAmount, token, resetForm) => {

  let error = false;
  let errors = {};

  const responseDispatches = { fail: CLAIM_ITEM_ADD_FAILED, success: CLAIM_ITEM_ADD_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const responseFunctions = { fail: null, success: resetForm };
  const showSnackBar = { fail: true, success: true };

  //strip non numbers and priods from amount to avoid allowing weird parsefloat returns
  claimItemObj.amount = claimItemObj.amount.replace(/[^\d.-]/g, '');

  if(typeof claimItemObj !== "object") { error = true; errors.GENERAL = 'Invalid claim item'; }

  //check duplicates, had to direct value compare, object to object wasnt working
  Object.values(claimItems).map( (item, index) => {
    if(
      item.patient == claimItemObj.patient &&
      parseInt(item.service) == parseInt(claimItemObj.service) &&
      (parseInt(item.service) != 1 && item.service_date == claimItemObj.service_date) &&
      item.provider == claimItemObj.provider &&
      parseFloat(item.amount) == parseFloat(claimItemObj.amount)
    ) { error = true; errors.GENERAL = 'Duplicate claim item, adjust some details'; return true; }
    return false;
  });

  if(!claimItemObj.patient || claimItemObj.patient === '') { error = true; errors.patient = 'Invalid patient'; }

  if(!claimItemObj.service_date || claimItemObj.service_date === '' || isNaN(Date.parse(claimItemObj.service_date))) { error = true; errors.service_date = 'Invalid service date'; }

  if(!claimItemObj.service || claimItemObj.service === '') { error = true; errors.service = 'Invalid service type'; }

  if(!claimItemObj.provider || claimItemObj.provider === '') { error = true; errors.provider = 'Invalid provider'; }

  if(!claimItemObj.amount || claimItemObj.amount === '' || isNaN(parseFloat(claimItemObj.amount))) { error = true; errors.amount = 'Invalid amount'; }

  if(claimItems.length >= 20) { error = true; errors.GENERAL = 'Maximum of 20 claim items allowed per claim'; }

  //basic validation checks and return so i can calculate specifics without erroring
  if(error === true) {
    errors.GENERAL = (errors.GENERAL)? errors.GENERAL : 'Please correct the claim details above';
    claimRequestFail(
      dispatch,
      error,
      errors,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail
    );
  }

  //advanced validation checks
  if(claimDateRangeObj){

    const minDate = new Date(claimDateRangeObj.min);
          minDate.setDate(parseInt(minDate.getDate())+1);
          minDate.setHours(0,0,0,0)

    const maxDate = new Date(claimDateRangeObj.max);
          maxDate.setDate(parseInt(maxDate.getDate())+1);
          maxDate.setHours(23,59,59,999)

    const currentDate = new Date();
    const serviceDate = new Date(claimItemObj.service_date);
          serviceDate.setDate(parseInt(serviceDate.getDate())+1);
          serviceDate.setHours(currentDate.getHours(),currentDate.getMinutes(),currentDate.getSeconds(),currentDate.getMilliseconds());

    if(serviceDate < minDate || serviceDate > maxDate) { error = true; errors.service_date = `Invalid service date`; }

    claimItemObj.dateTime = serviceDate;
    
  }

  //if(parseFloat(claimItemObj.amount) > parseFloat(submitableAmount)) { error = true; errors.amount = `Amount exceeds $${submitableAmount}`; }
  if(parseFloat(claimItemObj.amount) <= 0) { error = true; errors.amount = `Invalid amount`; }

  if(error === true) {
    errors.GENERAL = (errors.GENERAL)? errors.GENERAL : 'Please correct the claim details above';
    claimRequestFail(
      dispatch,
      error,
      errors,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail
    );
  } else {
    // claimRequestSuccess(
    //   dispatch,
    //   claimItemObj,
    //   'Claim Item has been successfully added',
    //   responseDispatches.success,
    //   responseRedirects.success,
    //   showSnackBar.success
    // );
    const data = {
      ee: employee,
      claimItem: claimItemObj,
      claimItems: claimItems,
      claimType: claimType
    };
    //claimRequest(dispatch, `${REACT_APP_API_URL}/claim/item/add`, data, responseDispatches, responseRedirects, showSnackBar, token, responseFunctions);
    //if(resetForm) resetForm();
    apiRequest(dispatch, history, token, '/claim/item/add', data, responseDispatches, responseRedirects, showSnackBar, responseFunctions, false, false);
  }

}

// ******************************************************************** //
export const claimItemRemove = (employee, claimType, claimItem, claimItems, token) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_ITEM_REMOVE });
    processClaimItemRemove(dispatch, employee, claimType, claimItem, claimItems, token);
  }
}

// ******************************************************************** //
const processClaimItemRemove = (dispatch, employee, claimType, claimItem, claimItems, token) => {

  let error = false;
  let errors = {};

  const responseDispatches = { fail: CLAIM_ITEM_REMOVE_FAILED, success: CLAIM_ITEM_REMOVE_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const responseFunctions = { fail: null, success: null };
  const showSnackBar = { fail: true, success: true };

  //remove claimItem from claimItems
  claimItems = claimItems.filter(function(item) {
    return item !== claimItem
  });

  const data = {
    ee: employee,
    claimItems: claimItems,
    claimType: claimType
  };

  //claimRequest(dispatch, `${REACT_APP_API_URL}/claim/item/remove`, data, responseDispatches, responseRedirects, showSnackBar, token, responseFunctions);
  apiRequest(dispatch, history, token, '/claim/item/remove', data, responseDispatches, responseRedirects, showSnackBar, responseFunctions, false, false);

}

// ******************************************************************** //
export const claimCancel = () => {
  return (dispatch) => {
    dispatch({ type: CLAIM_CANCEL });
    history.push('/claims');
  }
}

// ******************************************************************** //
export const claimSave = (employee, claimObj, totals, token) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_SAVE });
    processClaimSave(dispatch, employee, claimObj, totals, token);
  }
}

// ******************************************************************** //
const processClaimSave = (dispatch, employee, claimObj, totals, token) => {

  const responseDispatches = { fail: CLAIM_SAVE_FAILED, success: CLAIM_SAVE_SUCCESS };
  const responseRedirects = { fail: null, success: '/claims' };
  const responseFunctions = { fail: null, success: null };
  const showSnackBar = { fail: true, success: true };

  //remove unnecessary data thats bloating the post data
  const notallowed = ['patients', 'providers', 'services', 'incompleteClaims', 'claimReceipts', 'auditFiles'];

  const claim = Object.keys(claimObj)
    .filter(key => !notallowed.includes(key))
    .reduce((obj, key) => {
      return {
        ...obj,
        [key]: claimObj[key]
      };
    }, {});

  const data = {
    ee: employee,
    claim: claim,
    totals: totals
  };

  apiRequest(dispatch, history, token, '/claim/save', data, responseDispatches, responseRedirects, showSnackBar, responseFunctions, false, false);

}


// ******************************************************************** //
export const claimSubmit = (employee, claimObj, totals, token) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_SUBMIT });
    processClaimSubmit(dispatch, employee, claimObj, totals, token);
  }
}

// ******************************************************************** //
const processClaimSubmit = (dispatch, employee, claimObj, totals, token) => {

  const responseDispatches = { fail: CLAIM_SUBMIT_FAILED, success: CLAIM_SUBMIT_SUCCESS };
  const uploadDispatches = { fail: GENERAL_REQUEST_LOADED, success: GENERAL_REQUEST_LOADED };
  const responseRedirects = { fail: null, success: '/claims/success' };
  const showSnackBar = { fail: true, success: true };

  //save reciepts for upload call after submit
  const claimReceipts = claimObj.claimReceipts;

  //remove unnecessary data thats bloating the post data call
  const notallowed = ['patients', 'providers', 'services', 'incompleteClaims', 'claimReceipts', 'auditFiles'];

  const claim = Object.keys(claimObj)
    .filter(key => !notallowed.includes(key))
    .reduce((obj, key) => {
      return {
        ...obj,
        [key]: claimObj[key]
      };
    }, {});

  // add count for claim audit email to indicate if they have files uploaded
  claim.claimReceiptsCount = claimReceipts.length;

  const data = {
    ee: employee,
    claim: claim,
    totals: totals
  };

  // const upload_data = {
  //   ee: employee,
  //   claimId: claimObj.id,
  //   claimReceipts: claimReceipts
  // };

  // claimRequest(dispatch, `${REACT_APP_API_URL}/claim/submit`, data, responseDispatches, responseRedirects, showSnackBar, token, responseFunctions);
  // claimRequest(dispatch, `${REACT_APP_API_URL}/claim/upload`, upload_data, responseDispatches, null, null, token, null);
 
  const uploadDataFunction = (data, chunkIndex=0) => {
    if(data.length <= chunkIndex) return false;

    const responseFunctions = { fail: () => uploadDataFunction(data, chunkIndex+1), success: () => uploadDataFunction(data, chunkIndex+1)};

    apiRequest(dispatch, history, token, '/claim/upload', { ee: employee, claimId: claimObj.id, claimReceipts: [data[chunkIndex]]}, null, null, null, responseFunctions, false, false, true, false, true);
  }

  const responseFunctions = { fail: null, success: () => uploadDataFunction(claimReceipts, 0)};

  apiRequest(dispatch, history, token, '/claim/submit', data, responseDispatches, responseRedirects, showSnackBar, responseFunctions, false, false);

}

// ******************************************************************** //
export const claimStateCancel = (employee, claimId, token) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_STATE_CANCEL });
    processClaimStateCancel(dispatch, employee, claimId, token);
  }
}

// ******************************************************************** //
const processClaimStateCancel = (dispatch, employee, claimId, token) => {

  const responseDispatches = { fail: CLAIM_STATE_CANCEL_FAILED, success: CLAIM_STATE_CANCEL_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const responseFunctions = { fail: null, success: null };
  const showSnackBar = { fail: true, success: true };

  const data = {
    ee: employee,
    claimId: claimId,
  };

  //claimRequest(dispatch, `${REACT_APP_API_URL}/claim/cancel`, data, responseDispatches, responseRedirects, showSnackBar, token, responseFunctions);
  apiRequest(dispatch, history, token, '/claim/cancel', data, responseDispatches, responseRedirects, showSnackBar, responseFunctions, false, false);

}

// ******************************************************************** //
// ********* Resume Claim / Set Claim Details ************************* //
// ******************************************************************** //
export const setResumeClaimDetails = (employee, claim, type, submitableAmount, token, resetForm) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_CLEAR_ITEMS });
    setClaimDetails(dispatch, employee, claim, type, submitableAmount, token, resetForm);
  }
}

const setClaimDetails = (dispatch, employee, claim, type, submitableAmount, token, resetForm) => {

    let claimObj = {};
    let claimItems = [];
    let claimItemObj = {};
    let claimDateRange = {};

    claimObj.id = claim.CLAIM;
    claimObj.status = 'R';

    dispatch(setClaimId(claimObj.id));
    dispatch(setClaimStatus(claimObj.status));

    Object.values(claim.CLAIM_ITEMS).map( (item, index) => {
      claimItemObj = {
        patient: item.DEPENDANT,
        dateTime: item.SERVICE_DATE,
        provider: item.PROVIDER_NAME,
        provider_number: item.PROVIDER,
        service: item.SERVICE,
        service_name: item.SERVICE_NAME,
        service_date: item.SERVICE_DATE,
        amount: item.CLAIMED
      };

      //to bypass the validation requirement
      claimDateRange = {
        min: item.SERVICE_DATE,
        max: item.SERVICE_DATE
      };

      claimItems.push(claimItemObj);

    });

    //removes last claimitem from claimitems array, and becomes the checked claimItem via api call
    claimItems = claimItems.filter(function(item) {
      return item !== claimItemObj
    });

    //pass in empty claimItems list since the setting resume button clears claim items before re-adding
    dispatch(claimItemAdd(employee, type, claimItemObj, claimDateRange, claimItems, submitableAmount, token, resetForm));

    //claimItems = [];

    history.push('/claims/details');

}

// ******************************************************************** //
export const claimReceiptAdd = (imageObj, imagesArray) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_RECEIPT_ADD, imageObj });
    processReceiptAdd(dispatch, imageObj, imagesArray);
  }
}

// ******************************************************************** //
const processReceiptAdd = (dispatch, imageObj, imagesArray) => {

  let error = false;
  let errors = {};

  const responseDispatches = { fail: CLAIM_RECEIPT_ADD_FAILED, success: CLAIM_RECEIPT_ADD_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const showSnackBar = { fail: true, success: false };

  if(typeof imageObj !== "object") { error = true; errors.GENERAL = 'Invalid receipt image'; }

  //check duplicates, had to direct value compare, object to object wasnt working
  Object.values(imagesArray).map( (item, index) => {
    if(
      item.name === imageObj.name &&
      item.type === imageObj.type &&
      item.size === imageObj.size
    ) { error = true; errors.GENERAL = 'Duplicate receipt image'; return true; }
    return false;
  });

  //check if valid file types
  if(!inArray(['image/jpeg','image/png','application/pdf'],imageObj.type)) { error = true; errors.GENERAL = 'Invalid image type, please choose a JPEG, PNG, or PDF'; }

  //check if size is bigger than 4mb
  if(imageObj.size > HSAMaxImageSize) { error = true; errors.GENERAL = 'Maximum image size cannot exceed 5MB.'; }

  if(error === false) {
    claimRequestSuccess(
      dispatch,
      imageObj,
      'Claim Item has been successfully added',
      responseDispatches.success,
      responseRedirects.success,
      showSnackBar.success
    );
  } else {
    errors.GENERAL = (errors.GENERAL)? errors.GENERAL : 'Could not add receipt image';
    claimRequestFail(
      dispatch,
      error,
      errors,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail
    );
  }

}

// ******************************************************************** //
export const claimReceiptRemove = (receipt) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_RECEIPT_REMOVE, receipt });
    dispatch({ type: CLAIM_RECEIPT_REMOVE_SUCCESS });
    //validate return code
  }
}

// ******************************************************************** //
export const claimAuditReceiptsSubmit = (employee, claimId, receipts, token) => {
  return (dispatch) => {
    dispatch({ type: CLAIM_AUDIT_UPLOAD_SUBMIT });
    processClaimAuditReceiptsSubmit(dispatch, employee, claimId, receipts, token);
  }
}

// ******************************************************************** //
const processClaimAuditReceiptsSubmit = (dispatch, employee, claimId, receipts, token) => {

  const responseDispatches = { fail: CLAIM_AUDIT_UPLOAD_SUBMIT_FAILED, success: CLAIM_AUDIT_UPLOAD_SUBMIT_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const showSnackBar = { fail: true, success: true };

  // const data = {
  //   ee: employee,
  //   claimId: claimId,
  //   receipts: receipts
  // };


  const uploadDataFunction = (data, chunkIndex=0) => {
    if(data.length <= chunkIndex) return false;
    
    const responseFunctions = { fail: () => uploadDataFunction(data, chunkIndex+1), success: () => uploadDataFunction(data, chunkIndex+1)};

    apiRequest(dispatch, history, token, '/audit/upload', { ee: employee, claimId: claimId, receipts: [data[chunkIndex]]}, responseDispatches, null, null, responseFunctions, false, false, true, false, true);
  }

  
  const upload_data = (receipts[0])? [receipts[0]]: receipts;

  const responseFunctions = { fail: () => uploadDataFunction(receipts, 1), success: () => uploadDataFunction(receipts, 1)};

  apiRequest(dispatch, history, token, '/audit/upload', { ee: employee, claimId: claimId, receipts: upload_data}, responseDispatches, responseRedirects, showSnackBar, responseFunctions);

}

const claimRequestSuccess = (
  dispatch,
  data,
  message,
  responseDispatch,
  responseRedirect,
  showSnackBar,
  responseFunction
) => {
  dispatch({
    type: responseDispatch,
    data,
  });
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: message,
      severity: 'notificationBarSuccess',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if(responseFunction) responseFunction();
  if(responseRedirect) history.push(responseRedirect);
};

const claimRequestFail = (
  dispatch,
  error,
  errors,
  responseDispatch,
  responseRedirect,
  showSnackBar,
  responseFunction
) => {
  dispatch({
    type: responseDispatch,
    error,
    errors
  });
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: errors.GENERAL,
      severity: 'notificationBarFailed',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if(responseFunction) responseFunction();
  if(errors.FORCE_LOGOUT){
    // dispatch({
    //   type: LOGOUT,
    // });
    history.push('/logout');
  }else{
    if(responseRedirect) history.push(responseRedirect);
  }
};
